import { getState } from '../analytics-state';
import { getPageType } from '../thd-analytics-utils';
import { TABLEVIEW, TABLE } from '../constants';

export const productResults = () => {
  window.LIFE_CYCLE_EVENT_BUS.on('product-results.select-list-layout', (newLayout = {}) => {
    const state = getState();
    const { pageType: statePageType, currentPage, sortBy } = state || {};
    // Race condition fix: in case pageType is not yet set in state. getPageType is the same
    // function that populates state (route.listener.analytics.js), so the fallback stays in the
    // state vocabulary ('search'/'browse') rather than the DDO's ('search results'/'plp').
    const pageType = statePageType || getPageType();

    digitalData.event = digitalData.event || [];
    digitalData.event.push(
      {
        category: {
          primaryCategory: pageType || '',
        },
        eventInfo: {
          eventName: 'view type by',
        },
        displayAttributes: {
          pageNumber: currentPage || 0,
          productsAvailability: 'all products',
          sortBy: sortBy || 'bestmatch',
          viewType: newLayout.output || '',
        }
      }
    );
    if (digitalData?.page?.displayAttributes && newLayout?.output) {
      const viewType = newLayout?.output === TABLE ? TABLEVIEW : newLayout?.output;
      digitalData.page.displayAttributes.viewType = viewType;
    }
  });

};